(function() {
  'use strict';
  angular
    .module('app.user')
    .factory('PurchaseOrderService', PurchaseOrderService);

  PurchaseOrderService.$inject = [
    'APP_CONSTANTS',
    '$q',
    '$filter',
    'ApiCaller',
    'SubscriptionPlansService',
    'RegistrationService'
  ];

  function PurchaseOrderService(
    APP_CONSTANTS,
    $q,
    $filter,
    ApiCaller,
    SubscriptionPlansService,
    RegistrationService
  ) {
    var self = this;

    self.register = register;
    self.destroyRegistrationData = destroyRegistrationData;

    function register(poNumber) {
      var registrationInfo = RegistrationService.retrieveRegistrationInfo();
      var plan = SubscriptionPlansService.retrievePlan();

      registrationInfo.plan = plan.plan;
      registrationInfo.planId = plan.plan.id;
      registrationInfo.poNumber = poNumber;
      var deferred = $q.defer();
      var url = $filter('sprintf')(
        APP_CONSTANTS.userSignupWithPO,
        APP_CONSTANTS.rootUrl
      );

      ApiCaller.apiPost(url, registrationInfo).then(
        function(result) {
          deferred.resolve(result);
        },
        function(err) {
          deferred.reject(err);
        }
      );

      return deferred.promise;
    }

    function destroyRegistrationData() {
      SubscriptionPlansService.destroyPlan();
      RegistrationService.destroyRegistrationInfo();
    }

    return self;
  }
})();
